module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/1-f788deea9f1ac29364b37c6a8df8f214.svg";